(() => {
  const desktop = window.matchMedia('(min-width: 750px)');
  const accordions = document.querySelectorAll('[data-footer-accordion]');

  const syncAccordions = (event) => {
    accordions.forEach((accordion) => {
      accordion.open = event.matches;
    });
  };

  syncAccordions(desktop);
  desktop.addEventListener('change', syncAccordions);
})();
